import { render, staticRenderFns } from "./CreateCustomCounterDialog.vue?vue&type=template&id=3bffcd9d&scoped=true&"
import script from "./CreateCustomCounterDialog.vue?vue&type=script&lang=js&"
export * from "./CreateCustomCounterDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bffcd9d",
  null
  
)

export default component.exports